import request from "_private/utils/request";
export function FetchDangerousCollectList(data) {
    return request({
        url: "/report/cameraRisk/listRiskSummary",
        method: "post",
        headers: {type: "json"},
        data
    });
}
// 导出汇总页面数据
export function exportDangerousCollect(data) {
  return request({
      url: "/report/cameraRisk/exportRiskSummary",
      responseType: "blob",
      headers: {type: "json"},
      method: "post",
      data
  });
}
/**
 * 获取明细列表数据
 * @param {*} data
 */
export function FetchDangerousDetailList(data) {
  return request({
      url: "/report/cameraRisk/listRiskDetail",
      headers: {type: "json"},
      method: "post",
      data
  });
}

// 导出明细页面数据
export function exportDangerousDetail(data) {
  return request({
      url: "/report/cameraRisk/exportRiskDetail",
      responseType: "blob",
      headers: {type: "json"},
      method: "post",
      data
  });
}
// 获取企业下拉
export function FetchCorpList() {
  return request({
      url: "/base/compary/FetchCorpList",
      method: "post"
  });
}
// 获取仓库下拉
export function FetchStorageList() {
  return request({
    url: "/monitorCenter/monitorMapStorage/getStorageTree",
    method: "post"
  });
}
